<template>
    <div class="login-container">
        <div class="login-panel">
            <img src="../../assets/images/navitas_logo_white.png" alt="Navitas Safetey Group">
            <text-input label="E-mail / Username" hint="If you confirmed email, login with it, not username."
                        ref="username" @keyup.enter.native="actionLogin"/>
            <password-input label="Password" ref="password" @keyup.enter.native="actionLogin"/>

            <text-input label="2 Factor Authentication Code" hint="Enter the code provided from your google authenticator app."
                        ref="code" @keyup.enter.native="actionLogin" v-if="showFACode" />

            <text-button label="Sign in" :loading-state="loadingState" @click="actionLogin"/>
            <div style="display: flex; align-items: stretch;">
                <div class="login-link">
                    <a @click="actionFederatedEmailLogin">Sign in Using SSO</a>
                </div>
                <div class="forgot-password-link">
                    <a @click="actionForgotPassword">Forgot your password?</a>
                </div>
            </div>
        </div>
        <login-notice />
    </div>
</template>
<style>
.md-color-orange {
    color: #f1934b;
}
</style>
<script>
import TextInput from "../components/TextInput";
import PasswordInput from "../components/PasswordInput";
import TextButton from "../components/TextButton";
import {mapMutations} from "vuex";
import AuthService from "../../new/services/AuthService";
import LoginNotice from "../components/LoginNotice";

export default {

    name: "Login",
    components: {LoginNotice, TextButton, PasswordInput, TextInput},
    data() {
        return {
            loadingState: false,
            showFACode: false,
        }
    },
    methods: {
        actionLogin() {
            
            this.loadingState = true;
            
            this.$api.login({
                data: {
                    grant_type: 'password',
                    username: this.$refs.username.value,
                    password: this.$refs.password.value,
                    code: Object.prototype.hasOwnProperty.call(this.$refs, "code") ? this.$refs.code.value : null,
                }
            }).then(({data}) => {
                
                // Attempt to login the user
                AuthService.login(data)

                // On success, redrect to correct dashboard
                AuthService.redirectUserToTheOldAppOrDashboard();

            }).catch(({data, error}) => {
                
                // Did the login fail because a 2FA code is required? 
                if (data !== undefined && data !== null) {
                    if (Object.prototype.hasOwnProperty.call(data, "_2fa_enabled") === true) {
                        if (data._2fa_enabled === 1) {
                            this.showFACode = true;
                        }
                    }
                }

                // Other error
                if (error !== undefined && error !== null && error.status === 418) {
                    let token = data.token ?? '';
                    let email = data.email ?? '-';
                    let routePath = this.$enums.RoutePathEnum.ACCOUNT_CONFLICT;
                    routePath = routePath.replace(':token', token);
                    routePath = routePath.replace(':email', email);
                    this.$router.push(routePath);
                }

            }).finally(() => {
                this.loadingState = false;
            });

        },
        actionForgotPassword() {
            this.$router.push(this.$enums.RoutePathEnum.FORGOT_PASSWORD);
        },
        actionFederatedEmailLogin() {
            this.$router.push(this.$enums.RoutePathEnum.FEDERATED_EMAIL_LOGIN);
        },
        ...mapMutations('app', {
            setGlobalLoadingState: 'setGlobalLoadingState',
        })
    },
    mounted() {
        if (AuthService.isLogged()) {
            this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
        }

        let confirmEmailToken = this.$route.query.confirmEmailToken ?? '';

        if (confirmEmailToken.length > 0) {
            this.setGlobalLoadingState(true);
            this.$api.confirmEmail({
                data: {
                    token: confirmEmailToken
                }
            }).then(({data}) => {
                AuthService.login(data)
                /* Delay for setting cookies */
                setTimeout(() => {
                    this.setGlobalLoadingState(false);
                    this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
                }, 10);
            }).finally(() => {
                this.setGlobalLoadingState(false);
                this.$router.push(this.$enums.RoutePathEnum.LOGIN)
            });
        } else {
            this.setGlobalLoadingState(false);
        }
    }
}
</script>
